import React from 'react'
import { Link } from 'gatsby'
import Layout from '../../components/Layout'
import Seo from '../../components/Seo'

const day_nulm = () => {
	return (
		<Layout>
			<Seo title={`Day - NULM | NAC, Dharamgarh`} />
			<header className="header">
				<div className="header__jumbotron baseWrap df jcsb fww">
					<h2 className="sec_heading">Day - NULM</h2>
					<ol className="breadcrumb">
						<li className="breadcrumb-item">
							<Link to="/">Home</Link>
						</li>
						<li className="breadcrumb-item">
							<span>Information Center</span>
						</li>
						<li className="breadcrumb-item active">
							<span>Day - NULM</span>
						</li>
					</ol>
				</div>
			</header>
			<section className="sec sec_page df">
				<div className="baseWrap">
					<div className="contentWrap h100 ma shadow df aic">
						<ul className="collection">
							<li className="collection-item">
								<span><strong>97</strong> active SHGs in Dharamgarh are engaged in various work. They are involved in income generation programs through ULB (urban local body).</span>
							</li>
							<li className="collection-item">
								<span>Many people are under Day NULM and are engaged in work like Sanitation, Jal sathi.</span>
							</li>
						</ul>
					</div>
				</div>
			</section>
		</Layout>
	)
}

export default day_nulm
